import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
export var MEDIA_WRAPPER_TAG = 'data-media-vc-wrapper';
export var VcMediaWrapperProps = _defineProperty({}, MEDIA_WRAPPER_TAG, true);
export default function MediaWrapper(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", VcMediaWrapperProps, children);
}